import * as React from 'react';
import '../../../panels/panels.css';
import { Button, Label, Segment, Form, Checkbox, Dropdown, Input, Popup } from 'semantic-ui-react';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import Toast from '../../../sys/toast';
import OAuth, { OAuthClientStatus } from '../../../api';

class State {
    alarmSoakPeriod: string;
    alarmLogMessages: any;
    alarmSysOutageEna: boolean;
    alarmSysOutageThr: string;
    alarmVideoNewEna: boolean;
    alarmVideoOutageEna: boolean;
    bandwidthAlarmEnable: boolean;
    bandwidthAlarmThr: number;

}

interface Props {

}

export default class GlobalAlarmConfig extends React.Component<Props, State> {

    private alarmSoakPeriod: string; private alarmLogMessages: string; private alarmSysOutageEna: boolean;
    private alarmSysOutageThr: string; private alarmVideoNewEna: boolean; private alarmVideoOutageEna: boolean;

    componentWillMount() {
        this.setState({
            alarmSoakPeriod: '',
            alarmLogMessages: '',
            alarmSysOutageEna: false,
            alarmSysOutageThr: '',
            alarmVideoNewEna: false,
            alarmVideoOutageEna: false,
            bandwidthAlarmEnable: true, // SAN-4357 Enabled by default
            bandwidthAlarmThr: 0
        });

        this.fetchData();
        
    }

    fetchData() {
        let _this = this;
        let fmUrl = 'http://default/api/config/section/options/fm';
        let abrUrl = 'http://default/api/config/section/options/abr';

        let oauth, result: any, licenseFlowLimit: any;

        if (window.sessionStorage && (oauth = window.sessionStorage.getItem('oauth'))) {
            result = JSON.parse(oauth);
            licenseFlowLimit = result.sys && result.sys.licenseFlowLimit ? result.sys.licenseFlowLimit : 0;
        }

        axios.all([
            axios.post(fmUrl, {
                mode: 'get',
                defaults: {
                },
                options: [
                    'alarmSoakPeriod',
                    'alarmLogMessages',
                    'alarmSysOutageEna',
                    'alarmSysOutageThr',
                    'alarmVideoNewEna',
                    'alarmVideoOutageEna'
                ]
            }),
            axios.post(abrUrl, {
                mode: 'get',
                defaults: {
                },
                options: [
                    'bandwidthAlarmEnable',
                    'bandwidthAlarmThr'
                ]
            })
        ])
            .then(axios.spread((responseFM: AxiosResponse, responseABR: AxiosResponse) => {
                if (responseFM.data !== undefined && responseFM.data.section !== undefined) {
                    let responseObject = responseFM.data.section.options;

                    _this.alarmSoakPeriod = responseObject[0].value;
                    _this.alarmLogMessages = responseObject[1].value;
                    _this.alarmSysOutageEna = (responseObject[2].value === 'true');
                    _this.alarmSysOutageThr = responseObject[3].value;
                    _this.alarmVideoNewEna = (responseObject[4].value === 'true');
                    _this.alarmVideoOutageEna = (responseObject[5].value === 'true');

                    _this.setState({
                        alarmSoakPeriod: _this.alarmSoakPeriod,
                        alarmLogMessages: _this.alarmLogMessages,
                        alarmSysOutageEna: _this.alarmSysOutageEna,
                        alarmSysOutageThr: _this.alarmSysOutageThr,
                        alarmVideoNewEna: _this.alarmVideoNewEna,
                        alarmVideoOutageEna: _this.alarmVideoOutageEna

                    });
                } else {
                    // tslint:disable-next-line:no-console
                    console.log('expected array of config values, got ', responseFM.data);
                }
                if (responseABR.data !== undefined && responseABR.data.section !== undefined) {
                    let responseObject = responseABR.data.section.options;

                    _this.setState({
                        bandwidthAlarmEnable: responseObject[0].value,
                        bandwidthAlarmThr: responseObject[1].value  !== 0 ? responseObject[1].value : licenseFlowLimit <= 250 ? 300 : 700
                    });
                } else {
                    // tslint:disable-next-line:no-console
                    console.log('expected array of config values, got ', responseABR.data);
                }
            }))
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('fetchData() error: ', error);
            });

    }

    updateConfig(e: any, data: any, licenseFlowLimit: any) {
        //    let _this = this;

        let fmUrl = 'http://default/api/config/section/options/fm';
        let abrUrl = 'http://default/api/config/section/options/abr';

        this.setState({
            bandwidthAlarmThr: this.state.bandwidthAlarmThr  !== 0 ? this.state.bandwidthAlarmThr :
                licenseFlowLimit <= 250 ? 300 : 700
        });

        axios.all([
            axios.post(fmUrl, {
                mode: 'modify',
                defaults: {
                },
                options: [
                    {
                        'name': 'alarmSoakPeriod',
                        'value': this.state.alarmSoakPeriod
                    }, {
                        'name': 'alarmLogMessages',
                        'value': this.state.alarmLogMessages
                    }, {
                        'name': 'alarmSysOutageEna',
                        'value': this.state.alarmSysOutageEna
                    }, {
                        'name': 'alarmSysOutageThr',
                        'value': this.state.alarmSysOutageThr
                    }, {
                        'name': 'alarmVideoNewEna',
                        'value': this.state.alarmVideoNewEna
                    }, {
                        'name': 'alarmVideoOutageEna',
                        'value': this.state.alarmVideoOutageEna
                    }
                ]
            }),
                axios.post(abrUrl, {
                    mode: 'modify',
                    defaults: {
                    },
                    options: [
                        {
                            'name': 'bandwidthAlarmEnable',
                            'value': this.state.bandwidthAlarmEnable
                        }, {
                            'name': 'bandwidthAlarmThr',
                            'value': this.state.bandwidthAlarmThr
                        }
                    ]
            })
        ])
            .then(axios.spread((responseFM: AxiosResponse, responseABR: AxiosResponse) => {
                if (responseFM.data !== undefined && responseFM.data.code === 'SUCCESS' &&
                    responseABR.data !== undefined && responseABR.data.code === 'SUCCESS') {
                    Toast.info('Global alarm configuration applied');
                } else {
                    Toast.error('Global alarm configuration failed');
                }

            }))
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('updateConfig() error: ', error);
                Toast.error('Global alarm configuration failed');
            });
    }

    render() {
        const messageOptions = [
            { value: 'all', text: 'All Messages'},
            { value: 'alarm', text: 'Alarms Only'},
        ];
        return (
            <OAuth.Context>
                {(oauth: OAuthClientStatus) => {
                        const licenseFlowLimit = oauth.sys && oauth.sys.licenseFlowLimit ? oauth.sys.licenseFlowLimit : -1;
                        return (
                            <React.Fragment>
                                <div className="assetAliasFilters">
                                    <Label className="system-config-pageHeader">
                                        Global Alarms
                                    </Label>
                                    <Button
                                        floated="right"
                                        className="rightButton"
                                        content="Apply"
                                        title="Update Config"
                                        onClick={(e, data) => this.updateConfig(e, data, licenseFlowLimit)}
                                    />
                                </div>
                                <div className="vertical-flex-main">
                                <Segment.Group className="system-config-segment">
                                    <Segment className="segment-header">General</Segment>
                                    <Segment>
                                        <Form>
                                            <Form.Group grouped>
                                                <Label className="right-align-label-width500">
                                                    Continuous Alarm Clear Period to Clear a SET Alarm (secs)
                                                </Label>
                                                <Input
                                                    className="small-input"
                                                    maxLength={5}
                                                    value={this.state.alarmSoakPeriod}
                                                    onChange={(e: any, data: any) => this.setState({alarmSoakPeriod: data.value})}
                                                />
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label className="right-align-label-width500">
                                                    Message Types to be Logged in the Alarm Log
                                                </Label>
                                                <Dropdown
                                                    search
                                                    value={this.state.alarmLogMessages}
                                                    options={messageOptions}
                                                    selection
                                                    onChange={(event, data) => this.setState({alarmLogMessages: data.value})}
                                                />
                                            </Form.Group>
                                        </Form>
                                    </Segment>
                                </Segment.Group>
                                <Segment.Group className="system-config-segment">
                                    <Segment className="segment-header">Alarms - System</Segment>
                                    <Segment>
                                        <Form>
                                            <Form.Group grouped>
                                                <Label className="right-align-label-width500">
                                                    SYS-OUTAGE-15 : Outage Period value crossed for stream(s) (secs)
                                                </Label>
                                                <Popup
                                                    trigger={
                                                        <Checkbox
                                                            className="config-checkbox"
                                                            checked={this.state.alarmSysOutageEna}
                                                            onChange={(e: any, data: any) => this.setState({alarmSysOutageEna: data.checked})}
                                                        />
                                                    }
                                                    content="Report Status"
                                                />
                                                <Popup
                                                    trigger={
                                                        <Input
                                                            className="small-input-leftMargin"
                                                            maxLength={5}
                                                            value={this.state.alarmSysOutageThr}
                                                            onChange={(e: any, data: any) => this.setState({alarmSysOutageThr: data.value})}
                                                        />
                                                    }
                                                    content="Threshold Value"
                                                />
                                            </Form.Group>
                                        </Form>
                                    </Segment>
                                    {!oauth.VODOnlyLicensePresent ?
                                    <Segment className="segment-header">Alarms - Video</Segment>
                                    : null}
                                    {!oauth.VODOnlyLicensePresent ?
                                    <Segment>
                                        <Form>
                                            <Form.Group grouped>
                                                <Label className="right-align-label-width500">
                                                    VIDO-NEW : New Video Stream Detection
                                                </Label>
                                                <Popup
                                                    trigger={
                                                        <Checkbox
                                                            className="config-checkbox"
                                                            checked={this.state.alarmVideoNewEna}
                                                            onChange={(e: any, data: any) => this.setState({alarmVideoNewEna: data.checked})}
                                                        />
                                                    }
                                                    content="Report Status"
                                                />
                                            </Form.Group>
                                            {/*<Form.Group grouped>*/}
                                            {/*    <Label className="right-align-label-width500">*/}
                                            {/*        VIDO-LOS : Video Stream Outage.*/}
                                            {/*    </Label>*/}
                                            {/*    <Popup*/}
                                            {/*        trigger={*/}
                                            {/*            <Checkbox*/}
                                            {/*                className="config-checkbox"*/}
                                            {/*                checked={this.state.alarmVideoOutageEna}*/}
                                            {/*                onChange={(e: any, data: any) => this.setState({alarmVideoOutageEna: data.checked})}*/}
                                            {/*            />*/}
                                            {/*        }*/}
                                            {/*        content="Report Status"*/}
                                            {/*    />*/}
                                            {/*</Form.Group>*/}
                                        </Form>
                                    </Segment> : null}
                                    <Segment className="segment-header">Alarms - Bandwidth</Segment>
                                    <Segment>
                                        <Form>
                                            <Form.Group grouped>
                                                <Label className="right-align-label-width500">
                                                    MEDIA-BANDWIDTH : Enable/Disable
                                                </Label>
                                                <Popup
                                                    trigger={
                                                        <Checkbox
                                                            className="config-checkbox"
                                                            checked={this.state.bandwidthAlarmEnable}
                                                            onChange={(e: any, data: any) => this.setState({bandwidthAlarmEnable: data.checked})}
                                                        />
                                                    }
                                                    content="Bandwidth Alarm enabled/disabled."
                                                />
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label className="right-align-label-width500">
                                                    Bandwidth Threshold (Mbps)
                                                </Label>
                                                <Popup
                                                    trigger={
                                                        <Input
                                                            className="small-input"
                                                            maxLength={5}
                                                            value={this.state.bandwidthAlarmThr}
                                                            // value={this.state.bandwidthAlarmThr != 0 ? this.state.bandwidthAlarmThr :
                                                            //             licenseFlowLimit <= 250 ? 300 : 700 }
                                                            onChange={(e: any, data: any) => this.setState({bandwidthAlarmThr: data.value})}
                                                        />
                                                    }
                                                    content="If Bandwidth value is zero, then default value used: 300 Mbps if stream license limit less than or equal to 250, 700 Mbps otherwise."
                                                />
                                            </Form.Group>
                                        </Form>
                                    </Segment>
                                </Segment.Group>
                                </div>
                            </React.Fragment>
                        );
                    }}
                </OAuth.Context>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/config/monitoring/globalAlarmConfig.tsx